import styled from 'styled-components'

export const ReadonlyFieldSmallLabel = styled.span`
  color: ${p => p.theme.colors.$nightRider};
  font-size: ${p => p.theme.fonts.$xs};
  text-transform: uppercase;
`

ReadonlyFieldSmallLabel.displayName = 'ReadonlyFieldSmallLabel'
